var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBroadcastBlock = function SvgBroadcastBlock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M6 9.494H4a.4.4 0 0 0-.4.4v4c0 .221.18.4.4.4h2v-4.8zm1.6 0v4.8H11a1.6 1.6 0 0 1 .662.144l8.172 3.715a.4.4 0 0 0 .566-.365V6a.4.4 0 0 0-.566-.364l-8.172 3.715a1.6 1.6 0 0 1-.662.143H7.6zm1.824 6.4.628 2.447a1.8 1.8 0 0 1-1.743 2.247h-.935a1.8 1.8 0 0 1-1.744-1.352l-.807-3.143a.801.801 0 0 1-.025-.199H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h7l8.172-3.714A2 2 0 0 1 22 6v11.788a2 2 0 0 1-2.828 1.821L11 15.894H9.424zm-1.626 0H6.424l.756 2.944a.2.2 0 0 0 .194.15h.935a.2.2 0 0 0 .194-.25l-.68-2.645a.801.801 0 0 1-.025-.199z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E0E0E0",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#364355",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBroadcastBlock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/broadcast-block.60ff4306b2fc14f80aaaaa183bb43148.svg";